import React from 'react';

import { Textarea, TextareaProps, forwardRef } from '@chakra-ui/react';
import styled from '@emotion/styled';
import ResizeTextarea from 'react-textarea-autosize';

interface Props {
  /* 
      isReadOnly is there to show text with borders and without interaction. 
      relying on isDisabled prop to disable interaction.
      marking input as disabled as well
    */
  isReadOnly?: boolean;
  isDashed?: boolean;
  isClearable?: boolean;
  onClear?: () => void;
  minRows?: number;
}

type InputProps = Props & TextareaProps;

const StyledTextarea = styled(Textarea)`
  font-weight: normal;
  border-bottom: 1px solid #999999;
  border-left: 0;
  border-right: 0;
  border-top: 0;
  border-radius: 4px 4px 0px 0px;
  background: transparent;
  padding: 10px 12px;
  padding-left: 0px;
  ${({ isDashed }) => isDashed && 'border-bottom-style: dashed;'}
  &:hover {
    border-bottom: 1px solid #333333;
    ${(props) => props.$isReadOnly && 'border-bottom: none;'};
  }
  &:focus {
    /* background: white; */
    border-bottom: 1px solid #1565bc;
    /* box-shadow: 0px 2px 4px rgba(0, 142, 240, 0.1); */
    box-shadow: none;
    ${(props) => props.$isReadOnly && 'border-bottom: none;'};
  }
  &[aria-invalid='true'] {
    border-bottom: 1px solid #c62c02;
    border-left: 0;
    border-right: 0;
    border-top: 0;
    box-shadow: none;
    background: transparent;
    &:focus {
      /* background: white;
      box-shadow: 0px 2px 4px rgba(207, 102, 121, 0.1); */
      box-shadow: none;
    }
  }
  font-size: 14px;
  /* isReadOnly takes precedence over disabled. */
  ${(props) =>
    props.$isReadOnly &&
    `
    opacity: 1 !important; 
    cursor: auto !important;
    border-bottom: none;
    `};
`;

const AutoResizeInput = forwardRef<InputProps, 'textarea'>(({ minRows = 1, ...rest }, ref) => (
  <StyledTextarea
    minH="unset"
    overflow="hidden"
    w="100%"
    resize="none"
    ref={ref}
    minRows={minRows}
    as={ResizeTextarea}
    _placeholder={{ color: '#666666' }}
    {...rest}
  />
));
export { AutoResizeInput };
